<template>
  <div class="contactInformation-page">
      <!-- 帮助中心 -->
      <el-popover placement="bottom" trigger="hover" :popper-class="getPopoverClass">
        <div slot="reference" class="cursorPointer contactInformation-right-text">
          联系我们
        </div>
        <div class="customerService">
          <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="help">
            <a
              href="https://nvux21psg6t.feishu.cn/wiki/space/7542330985725689884?ccm_open_type=lark_wiki_spaceLink&open_tab_from=wiki_home"
              style="text-decoration: none;	color: #333333;"
              target="_blank"
            >
              <div class="helpNoHover">
                <img
                  src="@/assets/new-image/header/help.svg"
                  alt
                  style="width:14px;height: 14px;"
                />&nbsp;帮助文档
              </div>
              <div class="helpHover">
                <img
                  src="@/assets/new-image/header/helpHover.svg"
                  alt
                  style="width:14px;height: 14px;"
                />&nbsp;帮助文档
              </div>
            </a>
          </div>
          <div class="quest">
            <a
              href="https://www.yuque.com/yunduanxincrm/zegmqs/qdkd9d3q9f3z9c38?singleDoc# 《常见问题》"
              style="text-decoration: none;	color: #333333;"
              target="_blank"
            >
              <div class="questNoHover">
                <img
                  src="@/assets/new-image/header/help.svg"
                  alt
                  style="width:14px;height: 14px;"
                />&nbsp;常见问题
              </div>
              <div class="questHover">
                <img
                  src="@/assets/new-image/header/helpHover.svg"
                  alt
                  style="width:14px;height: 14px;"
                />&nbsp;常见问题
              </div>
            </a>
          </div>
          </div>

          <div class="toService displayStart">
            <div class="title">客服热线：</div>
            <div class="phone">
              020-28970151
              <span class="phoneBtn">
              <img
                src="@/assets/new-image/header/copy.svg"
                alt
                @click="copyBtn('020-28970151')"
                style="width: 16px;height:16px;cursor: pointer;"
                class="copyBtn"
              />
              <img
                src="@/assets/new-image/header/copyHover.svg"
                alt
                @click="copyBtn('020-28970151')"
                style="width: 16px;height:16px;cursor: pointer;"
                class="copyBtnHover"
              /></span>
            </div>
          </div>
          <div class="toService displayStart">
            <div class="title">周末客服： </div>
            <div class="phone">
              18925068928
              <span class="phoneBtn">
              <img
                src="@/assets/new-image/header/copy.svg"
                alt
                @click="copyBtn('18925068928')"
                style="width: 16px;height:16px;cursor: pointer;"
                class="copyBtn"
              />
              <img
                src="@/assets/new-image/header/copyHover.svg"
                alt
                @click="copyBtn('18925068928')"
                style="width: 16px;height:16px;cursor: pointer;"
                class="copyBtnHover"
              />
              </span>
            </div>
          </div>
          <div class="toService displayStart">
            <div class="title">飞书咨询：</div>
              <a
                href="https://www.feishu.cn/invitation/page/add_contact/?token=c84hf808-2dcf-4b14-88e0-5da0dc110471"
                target="_blank"
                style="text-decoration: none;"
              >
                <div class="phone">
                  客服1
                </div>
              </a>
            </div>
          <div class="wechatService">
            <div class="QRcode">
              <img
                src="@/assets/new-image/header/code-three.png"
                alt
                style="width:100%"
              />
              <span calss="title">云起小助手A</span>
            </div>
            <div class="QRcode">
              <img
                src="@/assets/new-image/header/code-three.png"
                alt
                style="width:100%"
              />
              <span calss="title">云起小助手B</span>
            </div>
          </div>
        </div>
      </el-popover>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'contactInformation',
  props: [],
  components: {

  },
  data() {
    return {

    };
  },
  mounted: function() {
   
  },
  created: function() {

  },
  computed: {
    ...mapGetters(["scaleValue"]),
    getPopoverClass() {
      return this.scaleValue > 1? "contactInformation-popper" : ""
    }
  },
  watch: {

  },
  methods: {
     //复制
		 copyBtn(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      let isTrue = document.execCommand("Copy"); // 执行浏览器复制命令
      if(isTrue) {
        this.$message.success("复制成功！")
      } else {
        this.$message.error("复制失败！")
      }
      oInput.remove();
    },
  },
};
</script>

<style lang="scss">
.contactInformation-popper{
  transform-origin: right top!important;
}
</style>

<style scoped lang="scss">
.displayStart{
	display: flex;
	align-items: center;
	justify-content: flex-start;
}
.contactInformation-page {
  // height: 100%;
  display: inline-block;
  // width: 100px;
  margin-right: 26px;
  .contactInformation-right-text {
    color: #fff;
    font-size: 12px;
  }
  .contactInformation-right-text:hover {
    font-weight: 600;
  }
}

.helpBlock{
    margin: 0 0 0 20px;
		font-size: 0;
    .title{
      margin-right: 4px;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 14px;
    }
    .helpCenterClick{
      display: none;
    }
}
.helpBlock:hover{
  .helpCenter{
    display: none;
  }
  .helpCenterClick{
    display: block;
  }
}
.help,.quest {
  margin-bottom: 31px;
  display: flex;
  // padding: 0 10px;
  justify-content: flex-start;

  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  color: #666666;
  cursor: pointer;
  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    width: 100px;
  }
}
.help {
  .helpNoHover{
    display: flex;
  }
  .helpHover{
    display: none;
  }
}
.quest{
  .questNoHover{
    display: flex;
  }
  .questHover{
    display: none;
  }
}
.help:hover{
  .helpHover{
    display: flex;
  }
  .helpNoHover{
    display: none;
  }
}
.help div:hover{
  color:#2E74FE;
}

.quest:hover{
  .questHover{
    display: flex;
  }
  .questNoHover{
    display: none;
  }
}
.quest div:hover{
  color:#2E74FE;
}
.customerService {
padding: 10px;
.title {
	font-weight: 400;
	font-size: 13px;
	color: #666666;
}
.toService {
	margin-bottom: 12px;
	.title{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		line-height: 14px;
	}
	.phone {
		display: flex;
		font-weight: 400;
		font-size: 12px;
		color: #333333;
		line-height: 14px;
		img {
			width: 12px;
			height: 12px;
			vertical-align: middle;
			margin-left: 6px;
		}
	}
}

.wechatService {
	margin-top: 17px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	.QRcode {
		width: 80px;
		height: 80px;
		.title{
			font-weight: 400;
			font-size: 12px;
			color: #666666;
			line-height: 14px;
			text-align: left;
		}
	}
}

  .copyBtnHover{
    display: none;
  }
  .copyBtn{
    display: block;
  }
}

.phoneBtn:hover {
  .copyBtn {
    display: none;
  }

  .copyBtnHover {
    display: block;
  }
}
</style>